var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6747 13.2408C17.1445 14.4945 16.3153 15.5993 15.2596 16.4585C14.2038 17.3177 12.9537 17.9053 11.6184 18.1697C10.2831 18.4342 8.90337 18.3675 7.59981 17.9756C6.29624 17.5836 5.10854 16.8783 4.14053 15.9213C3.17253 14.9643 2.4537 13.7847 2.04688 12.4857C1.64006 11.1867 1.55765 9.80783 1.80685 8.46962C2.05605 7.13141 2.62926 5.87461 3.47639 4.80911C4.32351 3.74361 5.41875 2.90185 6.66635 2.35742",
    stroke: "#FF725E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 9.99935C18.3333 8.905 18.1178 7.82137 17.699 6.81032C17.2802 5.79927 16.6664 4.88061 15.8926 4.10679C15.1187 3.33297 14.2001 2.71914 13.189 2.30035C12.178 1.88156 11.0943 1.66602 10 1.66602V9.99935H18.3333Z",
    stroke: "#FF725E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPie);
export default __webpack_public_path__ + "static/media/pie.c10cdccf94d4c62c3e67898236581da4.svg";
export { ForwardRef as ReactComponent };